import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingCartSimple, User, ShieldStar, List, X } from "@phosphor-icons/react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/shop", label: "RSN Vault", id: "nav-shop-link" },
  { to: "/#strike", label: "Name Bounty", id: "nav-strike-link" },
  { to: "/track", label: "Track Order", id: "nav-track-link" },
];

export default function Navbar() {
  const { items, setOpen } = useCart();
  const { user, logout } = useAuth();
  const [menu, setMenu] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-[#050505]/85 backdrop-blur-xl border-b border-white/10" data-testid="navbar">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 h-[68px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
          <img src="/brand/icon.webp" alt="" className="h-10 w-10 rounded-sm object-cover group-hover:rotate-[-6deg] group-hover:scale-110 transition-transform duration-200" />
          <span className="font-display text-2xl leading-none tracking-wide">BOMBER <span className="hot-text">RSNS</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <NavLink key={l.id} to={l.to} data-testid={l.id} className="font-rs text-[14px] font-bold tracking-[0.12em] uppercase text-[#ff981f] [text-shadow:2px_2px_0_#000] hover:text-white transition-colors relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[#ff2a55] hover:after:w-full after:transition-[width] after:duration-200">{l.label}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2 md:gap-4">
          {user?.role === "admin" && (
            <Link to="/admin" className="hidden sm:inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.18em] uppercase text-[#ff2a55] border border-[#ff2a55]/50 px-3 py-2 hover:bg-[#ff2a55]/10 transition-colors" data-testid="nav-admin-link"><ShieldStar size={16} weight="duotone" /> Command</Link>
          )}
          {user ? (
            <div className="hidden sm:flex items-center gap-3">
              <Link to="/account" className="flex items-center gap-2 text-[12px] font-bold tracking-[0.15em] uppercase text-[#ccc] hover:text-white transition-colors" data-testid="nav-account-link"><User size={18} weight="duotone" />{user.name}</Link>
              <button onClick={logout} className="text-[11px] tracking-[0.18em] uppercase text-[#777] hover:text-[#ff2a55] transition-colors" data-testid="nav-logout-button">Exit</button>
            </div>
          ) : (
            <Link to="/login" className="hidden sm:inline-flex text-[12px] font-bold tracking-[0.2em] uppercase text-[#ccc] hover:text-white transition-colors" data-testid="nav-login-link">Login</Link>
          )}
          <button onClick={() => setOpen(true)} className="relative btn-bomb !py-2 !px-4 !text-base" data-testid="nav-cart-button" aria-label="Open cart">
            <ShoppingCartSimple size={20} weight="fill" />
            <span data-testid="nav-cart-count">{items.length}</span>
          </button>
          <button className="md:hidden text-white" onClick={() => setMenu(!menu)} aria-label="Menu" data-testid="nav-mobile-toggle">{menu ? <X size={26} /> : <List size={26} />}</button>
        </div>
      </div>
      {menu && (
        <div className="md:hidden bg-[#0a0a0a] border-t border-white/10 px-5 py-5 space-y-4" data-testid="nav-mobile-menu">
          {links.map((l) => <Link key={l.id} to={l.to} onClick={() => setMenu(false)} className="block font-display text-2xl">{l.label}</Link>)}
          {user ? (
            <>
              <Link to="/account" onClick={() => setMenu(false)} className="block font-display text-2xl">My orders</Link>
              {user.role === "admin" && <Link to="/admin" onClick={() => setMenu(false)} className="block font-display text-2xl text-[#ff2a55]">Command</Link>}
              <button onClick={() => { logout(); setMenu(false); }} className="font-display text-2xl text-[#777]">Exit</button>
            </>
          ) : <Link to="/login" onClick={() => setMenu(false)} className="block font-display text-2xl">Login</Link>}
        </div>
      )}
    </header>
  );
}
